import React from 'react';
import { bonuses } from '../data/bonuses';
import { TopoLines } from './TopoLines';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="topo-dark w-full bg-forest-deep" data-id="element-22" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" data-id="element-23" data-mp="aujz88jhw32f">
        <div className="text-center" data-id="element-24" data-mp="ftmr0ragscsg">
          <p className="eyebrow text-ember" data-id="element-25" data-mp="fsliatgx82dw">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-paper sm:text-6xl" data-id="element-26" data-mp="1tbzdm1byu68">
            Five instant-use <span className="text-ember" data-id="element-27" data-mp="3o2eo3y7vil48">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-paper/80" data-id="element-28" data-mp="3t0ok2b1f9pqw">
            The volumes give you every call. These five clear the usual
            blockers — where to start, your country’s terms, customer calls,
            abbreviations and paperwork — so you can use it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-29" data-mp="3idwotkx5belr">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-forest-line bg-forest ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-30" data-mp="3dfv6j27jnjbc" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} loading="lazy" className="aspect-square w-full border-b border-forest-line object-cover" data-id="element-31" data-mp="2zhohmbkkotnt" /> :
          // Portada de respaldo con la identidad del producto
          <div className="topo-light relative flex aspect-[4/3] w-full flex-col justify-between overflow-hidden border-b border-forest-line bg-paper p-5" data-id="element-32" data-mp="nprn5h4g75pd">
                  <span className={`absolute inset-x-0 top-0 h-2 ${bonus.accent}`} data-id="element-33" data-mp="it15ipczw21u" />
                  <TopoLines className="pointer-events-none absolute -bottom-10 -right-8 h-40 w-40 text-bark/15" data-id="element-34" data-mp="3ciephdjl2d3u" />
                  <span className="mt-2 inline-flex h-14 w-14 items-center justify-center rounded-full bg-forest font-display text-2xl text-ember ring-4 ring-paper" data-id="element-35" data-mp="3hk3y6mjc2eor">
                    {bonus.number}
                  </span>
                  <div className="relative" data-id="element-36" data-mp="2tsosqkw9fh9a">
                    <span className="font-mono text-[10px] font-bold uppercase tracking-[1.5px] text-bark" data-id="element-37" data-mp="2ttq831kb6pwt">
                      Diagnostic Pro · Bonus {bonus.number}
                    </span>
                    <p className="mt-1 font-display text-3xl leading-tight text-pine" data-id="element-38" data-mp="32sbl6h70hcq7">
                      {bonus.title}
                    </p>
                  </div>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-39" data-mp="2a3wjewcw4qwt">
                <div className="flex flex-wrap items-center gap-2" data-id="element-40" data-mp="2f394pco45pxa">
                  <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-paper/65" data-id="element-41" data-mp="2f1fw3rtxwvmn">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-ember px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-pine" data-id="element-42" data-mp="22m83epeyq541">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl leading-snug text-paper" data-id="element-43" data-mp="1tjgqel6fv1aa">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-paper/75" data-id="element-44" data-mp="1omypjwe8bn38">
                  {bonus.body}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}